import styled from 'styled-components';

export const Container = styled.div`
  min-height: 150px;
  flex-direction: column;
  display: flex;
  align-items: stretch;
  justify-content: center;
`;
